import React from 'react';
import { IRequestContext } from '@msdyn365-commerce/core';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

const AuthorizedDealerBadge = ({ product, requestContext }: { product?: SimpleProduct; requestContext: IRequestContext }) => {
    const brand = React.useMemo(() => {
        const brandFromExt = product?.ExtensionProperties?.find(p => p.Key === 'Brand')?.Value?.StringValue;
        if (brandFromExt) {
            return brandFromExt;
        }

        return null;
    }, [product]);

    if (brand && requestContext.gridSettings) {
        const locale = requestContext.locale;
        const fileName = `Catalogs/${locale}/${brand.toUpperCase()}_AuthDLR_${locale}.png`;
        const categoryImageUrl = generateImageUrl(fileName, requestContext.apiSettings);

        if (categoryImageUrl) {
            const ImageData: Msdyn365.IImageData = { src: categoryImageUrl };
            return (
                <div className='hei-buybox-wrapper-auth-dlr'>
                    <Msdyn365.Image
                        className='hei-buybox-image__item'
                        altText={brand}
                        {...ImageData}
                        gridSettings={requestContext.gridSettings}
                        loadFailureBehavior='hide'
                        role='banner'
                        id={`${fileName}__authDLR`}
                    />
                </div>
            );
        }
    }

    return null;
};

export { AuthorizedDealerBadge };
